import { fetchPsap } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import { fetchUser, setTokens, postAuthTokenSuccess } from '@rsos/sinatra';
import { getUrlParameter } from '@rsos/utils';
import { configureUserScope } from '@rsos/utils/sentry';
import {
  APP_INIT_START,
  APP_INIT_SUCCESS,
  APP_INIT_FAILED,
} from '../actions/actionTypes';

export const appInitStart = () => ({
  type: APP_INIT_START,
});

export const appInitSuccess = () => ({
  type: APP_INIT_SUCCESS,
});

export const appInitFailed = error => ({
  type: APP_INIT_FAILED,
  error,
});

const SESSION_EXPIRED_QUERY_PARAM = '?session_expired=true';

const hardRedirect = to => {
  window.location = to;
};

// Data loading only. Whether the user may be here is decided by the route's
// <RequireAccess> guard in app/Main.tsx; the catch below handles authentication
// (no session / expired refresh token) rather than authorization.
const initialize = () => (dispatch, store) => {
  dispatch(appInitStart());
  const isLoggedIn = store().sinatra.user.isLoggedIn;

  const accessToken = getUrlParameter('access_token');
  if (accessToken) {
    const tokens = {
      refresh_token: null,
      token: accessToken,
    };
    setTokens(tokens);
    dispatch(postAuthTokenSuccess(tokens));
  }

  return dispatch(fetchUser())
    .then(user => {
      if (user && user.profile) {
        configureUserScope(user.profile);
      }

      const { sinatra } = store();
      const org = sinatra.user.currentOrg;
      if (!org?.name) {
        throw new Error('No admin organization for the current role');
      }

      // Unwrapped so a failed fetch fails initialization and lands on the error
      // page, rather than rendering the section against an empty PSAP.
      return dispatch(fetchPsap(`/psaps/${org.name}`)).unwrap();
    })
    .then(() => dispatch(appInitSuccess()))
    .catch(action => {
      const isRefreshTokenExpired = Boolean(action?.isRefreshTokenExpired);

      // Only redirect with session-expired UX when refresh-token renewal failed.
      if (isLoggedIn && isRefreshTokenExpired) {
        return hardRedirect(`/${SESSION_EXPIRED_QUERY_PARAM}`);
      }

      if (isLoggedIn) {
        if (action.error) {
          return dispatch(appInitFailed(action.error));
        }
        return dispatch(appInitFailed(action));
      }

      return hardRedirect('/');
    });
};

export default initialize;
